module.exports = __webpack_public_path__ + "img/meeting_url_hint2.48737cea.png";